import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditDepartment = () => {
  const location = useLocation();
  const departmentToEdit = location.state?.department;

  const [formValues, setFormValues] = useState({
    department_id: "",
    department_name: "",
    contact_no: "",
    email_address: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [touched, setTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    // console.log("departmient to editt: ", departmentToEdit);

    if (departmentToEdit) {
      setFormValues({
        department_id: departmentToEdit.department_id,
        department_name: departmentToEdit.department_name,
        contact_no: departmentToEdit.contact_no,
        email_address: departmentToEdit.email_address,
      });
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No user data found.");
      setLoading(false);
    }
  }, [departmentToEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formValues.contact_no.length < 8 || formValues.contact_no.length > 15) {
      setError(true);
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      if (departmentToEdit) {
        const reqBody = {
          department_id: formValues.department_id,
          department_name: formValues.department_name,
          contact_no: formValues.contact_no,
          email_address: formValues.email_address,
        };
        // const response = await updateStudent(studentToEdit._id, reqBody, reqHeader);
        const response = await axios.put(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-department/${departmentToEdit._id}`,
          reqBody,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.data.status === "success") {
          setSnackbarMessage("Updated successfully!");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
          setTimeout(() => {
            navigate("/department-list");
          }, 2000);
        }
        // // console.log("edit: ", response);
      }

      //   navigate("/students");
    } catch (err) {
      // console.log("eeeeeeeee",  err.response);
      
      if (err.response && err.response.status === 409) {
        setSnackbarMessage(
          "This department ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else {
        console.error("Error updating user:", err);
        setSnackbarMessage("Failed to update. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
            <form onSubmit={handleSubmit}>
              <div className="mb-20">
                <label
                  htmlFor="did"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department ID <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  required
                  id="did"
                  placeholder="Enter Department ID"
                  value={formValues.department_id}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        department_id: e.target.value,
                      });
                    }
                  }}
                />
              </div>
              <div className="mb-20">
                <label
                  htmlFor="department_name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="department_name"
                  placeholder="Enter Department Name"
                  value={formValues.department_name}
                  required
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues,
                        department_name: value,
                      });
                    }
                  }}
                  onBlur={() => setTouched(true)} // Mark as touched when losing focus
                />
              </div>
              <div className="mb-20">
                <label
                  htmlFor="contact_no"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Contact No.
                </label>
                <input
                  type="text"
                  className="form-control radius-8"
                  id="contact_no"
                  value={formValues.contact_no}
                  required
                  onChange={(e) => {
                    const regex = /^[0-9]*$/; // Only allows numeric input
                    const value = e.target.value;

                    if (
                      (regex.test(value) || value === "") &&
                      value.length <= 15
                    ) {
                      setFormValues({
                        ...formValues,
                        contact_no: value,
                      });
                    }
                  }}
                  onBlur={() => {
                    setIsMobileTouched(true); // Mark field as touched when focus is lost
                    if (
                      formValues.contact_no.length < 8 ||
                      formValues.contact_no.length > 15
                    ) {
                      setError(
                        "Contact number must be between 8 and 15 digits."
                      );
                    } else {
                      setError(""); // Clear error if valid
                    }
                  }}
                  placeholder="Enter your contact number"
                  maxLength={15} // Ensure no more than 15 characters
                />

                {isMobileTouched && (
                  <>
                    {formValues.contact_no &&
                      (formValues.contact_no.length < 8 ||
                        formValues.contact_no.length > 15) && (
                        <small className="text-danger-600">
                          Contact number must be between 8 and 15 digits.
                        </small>
                      )}
                  </>
                )}
              </div>
              <div className="mb-20">
                <label
                  htmlFor="email"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Email
                </label>
                <input
                  type="email"
                  className="form-control radius-8"
                  id="email"
                  placeholder="Enter Email"
                  value={formValues.email_address}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      email_address: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/department-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditDepartment;
